import React from 'react';

export default props => (
  <>
    <div className="advanced-management-terms--title">
      Bem-vindo à Conta Família. 
    </div>
    <p>
      Você está habilitado para ser gestor de uma Conta Família. Com essa permissão, 
      é possível indicar familiares e amigos que desejam ter contas vinculadas a você para 
      ampliar sua atuação no mercado de milhas.
    </p>
    <p>
      O vínculo entre as contas deve ser acordado diretamente por você e pelo participante 
      indicado. Com o vínculo ativo, você receberá os pagamentos das milhas negociadas nas 
      contas vinculadas.
    </p>
    <p>
      Para ativar o vínculo com um participante, basta vocês seguirem as etapas abaixo:
    </p>
    <ol className="advanced-management-terms--num">
      <li>Você indica um participante.</li>
      <li>O participante solicita o vínculo de conta e envia a documentação dele.</li>
      <li>Você aprova o pedido de vínculo e envia a sua documentação.</li>
      <li>A MaxMilhas analisa todos os documentos enviados.</li>
      <li>Caso esteja tudo certo, o vínculo de vocês será ativado.</li>
    </ol>
    <div className="advanced-management-terms--title">
      Você e o participante precisarão enviar os documentos abaixo:
    </div>
    <ul className="advanced-management-terms--items">
      <li>Documento de identificação com foto (frente e verso).</li>
      <li>Selfie segurando o documento de identificação ao lado do rosto.</li>
      <li>Declaração de Vínculo assinada e digitalizada.</li>
    </ul>
    <p>
      Depois do primeiro vínculo ativado, você precisará enviar apenas a Declaração de Vínculo 
      nas próximas indicações de participantes, combinado?
    </p>
  </>
)